import {useLayoutEffect,useState} from 'react';
import {overviewViewportBottom} from './overviewViewportBounds';

// Fill the visible window after the web topbar/native shell, rather than
// adding another viewport's height underneath them.
export default function useOverviewViewport() {
  const [element,setElement]=useState(null);
  useLayoutEffect(()=>{
    if(!element)return undefined;
    let frame=0;
    const measure=()=>{
      frame=0;
      const bottom=overviewViewportBottom(element);
      const offset=`${Math.max(0,Math.ceil(element.getBoundingClientRect().top+window.innerHeight-bottom))}px`;
      if(element.style.getPropertyValue('--overview-page-offset')!==offset)element.style.setProperty('--overview-page-offset',offset);
    };
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(measure);};
    measure();const observer=typeof ResizeObserver==='undefined'?null:new ResizeObserver(schedule);
    for(let parent=element.parentElement;parent&&parent!==document.body;parent=parent.parentElement)observer?.observe(parent);
    window.addEventListener('resize',schedule);window.visualViewport?.addEventListener('resize',schedule);
    return()=>{observer?.disconnect();if(frame)cancelAnimationFrame(frame);window.removeEventListener('resize',schedule);window.visualViewport?.removeEventListener('resize',schedule);};
  },[element]);
  return setElement;
}
